import { useCallback } from 'react';
import { useQuery } from '@apollo/client';
import { useBugsnagNotifier } from './useBugsnagNotifier';
import { featuredItemsRowQuery } from '../api/queries';
import { FeaturedItemsRowQuery } from '../graphql/graphql';
import { ITEMS_LIMIT } from '../utils/constants/homePage';

export const useFeaturedItems = () => {
  const { loading, data, error, fetchMore, refetch } =
    useQuery<FeaturedItemsRowQuery>(featuredItemsRowQuery, {
      variables: {
        first: ITEMS_LIMIT
      },
      notifyOnNetworkStatusChange: true
    });

  const items =
    data?.featuredItems?.edges?.flatMap(edge =>
      edge?.node ? [edge.node] : []
    ) || [];

  const onLoadMore = useCallback(() => {
    fetchMore<FeaturedItemsRowQuery>({
      variables: {
        first: ITEMS_LIMIT,
        cursor: data?.featuredItems?.pageInfo?.endCursor
      }
    });
  }, [data?.featuredItems?.pageInfo?.endCursor, fetchMore]);

  useBugsnagNotifier(error);

  return {
    items,
    loading,
    error,
    onLoadMore,
    refetch,
    isStopLoad: !!data && !data.featuredItems?.pageInfo?.hasNextPage
  };
};
